import { ServiceType } from "../ServiceManager";
import { AnalyticsEvent, AnalyticsEventType } from "./AnalyticsEvents";
import { IAnalyticsAdapter } from "./IAnalyticsAdapter";
import { ClientWebsiteConfig } from "../Config";

class FacebookAnalyticsAdapter implements IAnalyticsAdapter {
    Type: ServiceType = ServiceType.Analytics;
    Id: string = 'FacebookAnalyticsAdapter';
    FBQ: any = null;

    constructor(config: ClientWebsiteConfig) {
        this.FBQ = this.InitFBEvents();

        config.Settings?.Analytics.FacebookTrackingIds.forEach(id => {
            this.FBQ('init', id);
        });
    }

    InitFBEvents(): any {
        function init(f: any,b: any,e: any,v: any,n: any,t: any,s: any) {
            if(f.fbq) return;

            n = f.fbq = function() {
                n.callMethod ? n.callMethod.apply(n, arguments) : n.queue.push(arguments);
            };

            if(!f._fbq) f._fbq = n;
            
            n.push = n;

            n.loaded = !0;

            n.version = '2.0';

            n.queue = [];
            t = b.createElement(e);
            t.async = !0;
            t.src = v;
            s = b.getElementsByTagName(e)[0];
            s.parentNode.insertBefore(t, s);

            return f.fbq;
        }

        return init(window, document,'script', 'https://connect.facebook.net/en_US/fbevents.js', null, null, null);
    }

    Record(event: AnalyticsEvent): void {
        switch(event.Type) {
            case AnalyticsEventType.PageView:
                this.FBQ('track', 'PageView');
                break;
            case AnalyticsEventType.ContactFormSubmit:
                this.FBQ('track', 'Contact');
                break;
        }
    }
}

export { FacebookAnalyticsAdapter }
